import { useCallback } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
export function SubscriptionChickletPrimaryDisplayLabel({
  toObjectId,
  toObjectTypeId,
  canView,
  properties,
  onPreview
}) {
  const handlePreviewClick = useCallback(() => {
    if (onPreview) onPreview({
      objectTypeId: toObjectTypeId,
      objectId: toObjectId
    });
  }, [onPreview, toObjectTypeId, toObjectId]);
  const subscriptionName = getPropertyValueFromProperties(properties, 'hs_name') || DISPLAY_LABEL_FALLBACK;
  if (!canView) {
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "subscription-chicklet-title",
      "data-test-id": "subscription-chicklet-title",
      children: /*#__PURE__*/_jsx("strong", {
        "data-selenium-test": "subscription-chicklet-title-read-only",
        "data-test-id": "subscription-chicklet-title-read-only",
        "data-unit-test": "subscription-chicklet-title-read-only",
        children: subscriptionName
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "subscription-chicklet-title",
    "data-test-id": "subscription-chicklet-title",
    children: /*#__PURE__*/_jsx(Link, {
      onClick: handlePreviewClick,
      children: /*#__PURE__*/_jsx("span", {
        "data-selenium-test": "subscription-chicklet-title-link",
        "data-test-id": "subscription-chicklet-title-link",
        children: subscriptionName
      })
    })
  });
}